/**
 * Firebase Configuration & Initialization
 * Central place for Firebase setup and exports
 */

import { initializeApp, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';
import { getFunctions } from 'firebase/functions';

// Firebase configuration
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyA...',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'gavekort-multitenant.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'gavekort-multitenant',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'gavekort-multitenant.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '563584335869',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:563584335869:web:...',
};

// Initialize Firebase - check if already initialized
let app;
try {
  app = getApp();
} catch (error) {
  app = initializeApp(firebaseConfig);
}

// Export Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);
export const functions = getFunctions(app, 'europe-west1');

export default app;
